import * as React from 'react';

import {
	StyledHeader,
	Title,
	Toggle,
	ButtonClose,
} from '../styles';
import Utils from '../../../utils';

interface HeaderProps {
	isToastExpanded: boolean;
	downloadedItems: number;
	totalItems: number;
	onToggle: () => void;
	onClose: () => void;
	isCheckingForUpdates: boolean;
}

const Header = ({
	isToastExpanded,
	downloadedItems,
	totalItems,
	onToggle,
	onClose,
	isCheckingForUpdates,
}: HeaderProps) => {
	let title = '';

	if (totalItems === 0) {
		title = 'messages.downloading';
	} else if (isCheckingForUpdates) {
		title = 'messages.download_manager';
	} else {
		title = 'messages.download_toast_status';
	}

	return (
		<StyledHeader>
			<Title
				value={title}
				downloadedItems={downloadedItems}
				totalItems={totalItems}
			/>
			<Toggle
				type="button"
				isExpanded={isToastExpanded}
				onClick={onToggle}
			>
				{Utils.getSvgIcon('iconset_down')}
			</Toggle>
			<ButtonClose
				type="button"
				onClick={onClose}
			>
				{Utils.getSvgIcon('iconset_close-2')}
			</ButtonClose>
		</StyledHeader>
	);
};

export default Header;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DownloadGroupToast/Header/index.tsx